import { isEmpty, isEqual } from 'lodash'
import { getDiagnosis } from './diagnosis'

/**
 * @callback Hypothesis
 * @param {Record<string, any>} answers
 * @param {object} patient
 * @param {number} version
 * @returns {{text: string, helperText?: string, diagnoses: string[], cid: string}?}
 */

/**
 * @callback Diagnosis
 * @param {Record<string, any>} answers
 * @param {object} patient
 * @returns {{text?: string, proceed?: boolean}}
 */

/** @type {Hypothesis} */
function hypothesis(answers, patient, version) {
  const diagnosisFns = [
    getDiagnosis('first', version),
    getDiagnosis('second', version),
    getDiagnosis('third', version),
    getDiagnosis('fourth', version),
  ]
  let partialHypothesis = []

  for (const diagnosisFn of diagnosisFns) {
    const { text, proceed } = diagnosisFn?.(answers, patient)

    if (text) {
      partialHypothesis.push(text)
    }

    if (!proceed) {
      break
    }
  }

  if (!partialHypothesis.length) {
    return null
  }

  let hypothesis = partialHypothesis.join(' ')

  if (hypothesis == 'Asma grave não eosinofílica não alérgica') {
    hypothesis = 'Asma grave T2 baixo (não eosinofílica e não alérgica)'
  }

  const helperTextMap = {
    Asma: 'Considerar fenotipagem do paciente',
    'Asma grave': 'Indicado fenotipagem do paciente',
  }

  const cidMap = {
    Asma: 'J45',
    'Asma grave': 'J45',
    'Asma grave eosinofílica': 'J45.1',
    'Asma grave não eosinofílica': 'J45.0',
    'Asma grave alérgica': 'J45.0',
    'Asma grave não alérgica': 'J45.0',
    'Asma grave eosinofílica alérgica': 'J45.8',
    'Asma grave eosinofílica não alérgica': 'J45.1',
    'Asma grave não eosinofílica alérgica': 'J45.0',
    'Asma grave T2 baixo (não eosinofílica e não alérgica)': 'J45.1',
  }

  return {
    text: hypothesis,
    helperText: helperTextMap[hypothesis],
    diagnoses: partialHypothesis,
    cid: cidMap[hypothesis],
  }
}

export default hypothesis
